// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"550c42b4","208":"88df9361","304":"98e891fc","380":"8df1c0e7","424":"bb7f713c","592":"5ce4606b","640":"ee2336c7","888":"09f944bc","936":"793089ae"}[chunkId] + ".chunk.js";
};